import * as React from 'react';
import { Input, Box, Button, Typography, TextField } from '@mui/material';
import { db } from './firebase/firebaseConfig';
import { query, orderBy, limit, collection, onSnapshot } from "firebase/firestore";

function Watcher() {

    const [nayta, setNayta] = React.useState(false);
    const [naytaTiedot, setNaytaTiedot] = React.useState(false);
    const [queryFields, setQueryFields] = React.useState([
        {
            firstName: '', lastName: '', allergies: '', id: null,
            lactose: false, egg: false, gluten: false, vegan: false,
            vege: false, ride: false, date: new Date()
        }]);

    const [laskuri, setLaskuri] = React.useState([
        {
            kasvis: 0, laktoosi: 0, gluteeni: 0, vegaani: 0, muna: 0, kyyti: 0,
        }]);


    function count (taulu) {
        let tulos = "";
        let lasku = laskuri;
        // Lasketaan, iteroidaan taulu
        for (var i = 0; i < taulu.length; i++) {
            tulos = tulos + (i + 1).toString() + ".\n" + taulu[i].lastName + " " + taulu[i].firstName + " " + "\n\n";
            
            // Totuusarvojen tarkistus
            if (taulu[i].egg) {
                lasku[0].egg = lasku[0].egg + 1;
            }
            if (taulu[i].lactose) {
                lasku[0].laktoosi = lasku[0].laktoosi + 1;
            }
            if (taulu[i].gluten) {
                lasku[0].gluteeni = lasku[0].gluteeni + 1;
            }
            if (taulu[i].vegan) {
                lasku[0].vegaani = lasku[0].vegaani + 1;
            }
            if (taulu[i].vege) {
                lasku[0].kasvis = lasku[0].kasvis + 1;
            }
            if (taulu[i].ride) {
                lasku[0].kyyti = lasku[0].kyyti + 1;
            }
        }
        //console.log(tulos)
        return lasku;
    }
        

    async function generateList() {
        const taulu = [];
        const lahde = db.collection('Lomake');
        const snapshot = await lahde.orderBy("lastName").get();
        //console.log(snapshot)
        if (snapshot.empty) {
            console.log("No documents");
            return;
        }

        snapshot.forEach(doc => {
            //console.log(doc.id, '=>', doc.data());
            //let arvo = doc.data()
            taulu.push(doc.data());
        });

        // Aseta kyselyn tulos muuttujaan
        setQueryFields(taulu)

        // Formatointi
        //const tulos = taulu.map( (e,i) => (i+1+". "+e) ).join('\n');

        const palautus = await count(taulu);
        setLaskuri(palautus);

        // Näytä tulos
        setNayta(true);
    }

    const paivitaNakyvyys = (e) => {
        if (naytaTiedot) {
            setNaytaTiedot(false);
        }
        else {
            setNaytaTiedot(true);
        }   
    }

    const paivita = (e) => {
        document.location.reload();
    }

    return (
        <Box
            sx={{
                //width: '100vw',
                height: '100vh',
                display: 'flex',
                //alignContent: 'center',
                alignItems: 'center',
                flexDirection: 'column',
            }}
        >
            <Box
                sx={{
                    display: 'flex',
                    //minWidth: '25vw',
                    //width: { sx: '75vw', md: '25vw',},
                    maxWidth: '75vw',
                    bgcolor: 'white',
                    marginTop: '5vh',
                    marginBottom: '5vh',
                    //marginBottom: '10vh',
                    padding: '10px',
                    borderRadius: '8px',


                    flexDirection: 'column',
                    //flexWrap: 'wrap',
                    justifyContent: 'space-between',
                    //overflow: 'scroll',
                }}
            >
                <Typography
                    variant="h5"
                    component="h2"
                    sx={{
                        fontSize: '1.5rem',
                        margin: 0,
                        padding: 0,
                    }}
                >
                    Osallistujat
                </Typography>
                {!nayta &&
                    <Box
                        id="tulo"
                        sx={{
                            maxWidth: '100%',
                            height: '100%',
                            margin: '5px',
                        }}
                    >
                        Paina painiketta, jotta saat listan osallistujista.
                    </Box>
                }
                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: 'row',
                        flexWrap: 'wrap',
                    }}
                >
                    <Box>
                        {nayta &&

                            queryFields.map((queryField, i) => (
                                <div

                                    key={(queryField.id)}
                                    sx={{

                                        /*<Input
                                        sx={{
                                            //marginTop: '1.5vh',
                                            maxWidth: '100%',
                                            width: '200px',
                                            padding: 0,
                                        }}
                                        disableUnderline={true}
                                        variant="standard"
                                        value={i + 1 + ". " + queryField.lastName + " " + queryField.firstName}
                                    /> */
                                    }}
                                >

                                    <Typography
                                        variant="body1"
                                        component="p"
                                    >
                                        {(i < 99 ? '0' : '') + (i < 9 ? '0' : '') + (i + 1) + ". " + queryField.lastName + " " + queryField.firstName}
                                    </Typography>
                                    {naytaTiedot &&
                                        <Box
                                            sx={{
                                                marginLeft: '1.8rem',
                                            }}
                                        >
                                            {queryField.lactose &&
                                                <Typography
                                                    variant="body2"
                                                    color="textSecondary"
                                                    component="p"
                                                >
                                                    {">laktoositon"}
                                                </Typography>
                                            }
                                            {queryField.vege &&
                                                <Typography
                                                    variant="body2"
                                                    color="textSecondary"
                                                    component="p"
                                                >
                                                    {">kasvis"}
                                                </Typography>
                                            }
                                            {queryField.gluten &&
                                                <Typography
                                                    variant="body2"
                                                    color="textSecondary"
                                                    component="p"
                                                >
                                                    {">gluteeniton"}
                                                </Typography>
                                            }
                                            {queryField.egg &&
                                                <Typography
                                                    variant="body2"
                                                    color="textSecondary"
                                                    component="p"
                                                >
                                                    {">munaton"}
                                                </Typography>
                                            }
                                            {queryField.vegan &&
                                                <Typography
                                                    variant="body2"
                                                    color="textSecondary"
                                                    component="p"
                                                >
                                                    {">vegaani"}
                                                </Typography>
                                            }
                                            {queryField.ride &&
                                                <Typography
                                                    variant="body2"
                                                    color="textSecondary"
                                                    component="p"
                                                >
                                                    {">kyyditettävä"}
                                                </Typography>
                                            }
                                            {queryField.allergies !== "" &&
                                                <div>
                                                    <Typography
                                                        variant="body2"
                                                        color="textSecondary"
                                                        component="p"
                                                    >
                                                        {">vapaa kenttä: "}
                                                    </Typography>
                                                    <Typography
                                                        variant="body2"
                                                        color="textSecondary"
                                                        component="p"
                                                    >
                                                        {"-->" + queryField.allergies}
                                                    </Typography>
                                                </div>
                                            }
                                            
                                        </Box>
                                    }
                                </div>
                            ))
                        }
                    </Box>
                </Box>

                {nayta &&
                    <Box
                        id="piilolaatikko"
                        sx={{
                            //display: 'flex',
                        }}
                    >
                        <Typography
                            variant="h6"
                            component="h3"
                            sx={{
                                fontSize: '1.25rem',
                                marginTop: '10px',
                                //margin: 0,
                                padding: 0,
                            }}
                        >
                            Poikkeukset
                        </Typography>
                        <Typography
                            variant="body1"
                            component="p"
                        >
                            {"Kyyditettävät: " + laskuri[0].kyyti}
                        </Typography>
                        <Typography
                            variant="body1"
                            component="p"
                        >
                            {"Laktoosittomia: " + laskuri[0].laktoosi}
                        </Typography>
                        <Typography
                            variant="body1"
                            component="p"
                        >
                            {"Gluteenittomia: " + laskuri[0].gluteeni}
                        </Typography>
                        <Typography
                            variant="body1"
                            component="p"
                        >
                            {"Munattomia: " + laskuri[0].muna}
                        </Typography>
                        <Typography
                            variant="body1"
                            component="p"
                        >
                            {"Vegaaneja: " + laskuri[0].vegaani}
                        </Typography>
                        <Typography
                            variant="body1"
                            component="p"
                        >
                            {"Kasvissyöjiä: " + laskuri[0].kasvis}
                        </Typography>
                    </Box>
                }
                {!nayta &&
                    <Button
                        sx={{ marginTop: '7.5px' }}
                        onClick={generateList}
                        variant="contained"
                    >
                        Nouda Osallistujat
                    </Button>
                }
                {nayta &&
                    <Button
                        sx={{ marginTop: '7.5px' }}
                        onClick={paivitaNakyvyys}
                        variant="contained"
                    >
                        Näytä yksityistiedot
                    </Button>
                }
                {nayta &&
                    <Button
                        sx={{ marginTop: '7.5px' }}
                        onClick={paivita}
                        variant="contained"
                    >
                        Takaisin
                    </Button>
                }
            </Box>
            <Box sx={{ color: 'transparent' }}>.</Box>
        </Box>
    );
}

export default Watcher;